import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-039022e3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box-bar" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "translate" })
], -1))
const _hoisted_3 = { class: "user-layout" }
const _hoisted_4 = {
  key: 0,
  class: "layout-left"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box-bottom" }, [
  /*#__PURE__*/_createElementVNode("span", null, "客服邮箱：cs@cluan.cn"),
  /*#__PURE__*/_createElementVNode("span", null, "客服电话：400-600-9100")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.routeItem.path == '/user/login' || _ctx.routeItem.path == '/user/register')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4))
        : _createCommentVNode("", true),
      _createVNode(_component_router_view)
    ]),
    _hoisted_5
  ]))
}